<template>
  <div class="flex flex-col h-full overflow-hidden">
    <top-menu :show-buttons="false" />
    <div class="flex flex-grow w-full overflow-hidden">
      <div class="flex flex-col h-full overflow-x-hidden shrink w-full">
        <routes-access
          :items="validationRoutes"
          :message="validationRoutesMessage"
          :popupVisible="popupVisible"
        />
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'empty-layout',
};
</script>

<script setup>
import { ref } from 'vue';

import TopMenu from '@/layouts/main-layout/components/top-menu/ai-top-menu.vue';

const validationRoutesMessage = ref('');
const validationRoutes = ref([]);
const popupVisible = ref(false);
</script>
